import StepLine from 'modules/common/StepLine';
import PropTypes from 'prop-types';
import React from 'react';

export const StepLines = ({
  steps,
  courseSlug,
  isDegree,
  stageSlug,
  stepsProgress,
  currentStepId,
  trackSlug,
  subscription,
}) => {
  return (
    <div className="pv3 ph4">
      {steps.map((step) => (
        <StepLine
          key={step.id}
          step={step}
          courseSlug={courseSlug}
          current={currentStepId === step.id}
          isDegree={isDegree}
          stageSlug={stageSlug}
          stepProgress={stepsProgress[step.id] || 'not started'}
          trackSlug={trackSlug}
          isLocked={step.isLocked}
          subscription={subscription}
        />
      ))}
    </div>
  );
};

StepLines.propTypes = {
  isDegree: PropTypes.bool,
  trackSlug: PropTypes.string,
  steps: PropTypes.array.isRequired,
  courseSlug: PropTypes.string.isRequired,
  stageSlug: PropTypes.string.isRequired,
  stepsProgress: PropTypes.object.isRequired,
  currentStepId: PropTypes.number.isRequired,
};

export default StepLines;
